import { Component, OnInit, TemplateRef, ViewChild, Compiler, ChangeDetectorRef } from '@angular/core';
import { HomeService } from 'src/app/home/services/home.service';
import { Router } from '@angular/router';
import { StatePersistService } from 'src/app/core/services/state-persist.service';
import { SharedService } from '../../services/shared.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { AlertService } from 'src/app/core/services/alert.service';
import { environment } from 'src/environments/environment';
import { Subscription } from 'rxjs';
import { GoogleAnalyticsService } from '../../services/google-analytics.service';
import { SharedConsts } from '../../constants';

var CryptoJS = require("crypto-js");


@Component({
    selector: 'select-address',
    templateUrl: './select-address.component.html',
    styleUrls: ['./select-address.component.scss', '../header/header.component.scss'],
    standalone: false
})
export class SelectAddressComponent implements OnInit {
  @ViewChild('template', {static: true}) templateRef: TemplateRef<any>;
  @ViewChild('deactiveStoreTemplate', {static: true}) templateRef2: TemplateRef<any>;
  @ViewChild('storeNotExistTemplate', {static: true}) templateRef3: TemplateRef<any>;
  subscriptions: Subscription[] = [];
  modalRef: BsModalRef;
  sub1: any;
  sub2: any;
  sub3: any;
  sub4: any;
  searchText = '';
  page_size = environment.page_size
  stores = [];
  retailers = []
  addressDisabled: any = false;
  retailerDisabled: any = false;
  selectedStorePromotionApply: any = false;
  selectedStoreName = '';
  selectedStoreAccountNo = '';
  selectedRetailerName = '';
  loading = false;
  componentLoaded = false;
  nextPage = 1;
  totalRetailerPages = 1;
  totalRetailerCount = 0;
  noRecord = true;
  searchEntered = false;
  is_store_input_disabled = false;
  store_data: any = {};
  constructor(private homeService: HomeService,
    private googleAnalyticsService: GoogleAnalyticsService,
    private modalService: BsModalService,
    private sharedService: SharedService,
    private alertService: AlertService,
    private _compiler: Compiler,
    private router: Router, private statePersist: StatePersistService,
    private cdRef: ChangeDetectorRef) {
      this.router.routeReuseStrategy.shouldReuseRoute = function(){
        return false;
 }
 
     }

     

applySearch(text){
  this.searchText = text;
  this.searchEntered = true;
  this.getretailerList()
}
changeValue(event){
  this.searchEntered = false;
  this.searchText = event.target.value.trim();
}
clearSearch(){
  this.searchText = '';
  this.retailers = [];
  this.nextPage = 1;
  this.noRecord = true;
  this.totalRetailerPages = 0;
  this.totalRetailerCount = 0;
  this.searchEntered = false;
  setTimeout(() => {
    document.getElementById('search-input').setAttribute('autofocus', 'autofocus')
    document.getElementById('search-input').focus()
  }, 0);
  
}
cancelSearch(){
  this.searchText = '';
  this.retailers = [];
  this.nextPage = 1;
  this.noRecord = true;
  this.totalRetailerPages = 0;
  this.totalRetailerCount = 0;
  this.searchEntered = false;
  this.modalRef.hide()
  this.statePersist.setLocalStorage('default_popup_hide', true)
}
searchReatiler(event){
  if (event.key === "Enter") {
    event.target.blur()
    this.searchText = event.target.value.trim();
    this.noRecord = true;
    this.retailers = [];
    this.nextPage = 1;
    this.totalRetailerCount = 0;
    this.totalRetailerPages = 1
    this.searchEntered = true;
    this.getretailerList(event)
  }
  else{
    this.searchText = event.target.value.trim();
  }
  
}
openModalWithClass(template: TemplateRef<any>) {
    setTimeout(() => {
      this.modalRef = this.modalService.show(
        template,
        Object.assign({}, { class: 'modal-dialog-centered store-modal' })
      );

    }, 0);
  }

  ngOnInit(): void { 
    this.store_data = this.statePersist.getLocalStorage('redirected_user_data') || '';
    if (this.store_data){
      this.store_data = JSON.parse(this.store_data)
    }
    
    this.sub1 = this.statePersist.watchAddressStorage().subscribe(message => {
      this.addressDisabled = this.statePersist.getLocalStorage('address-disabled')
      if (this.store_data){
        this.addressDisabled = true
      }
    })

    this.sub2 = this.statePersist.watchRetailerStorage().subscribe(message => {
      this.retailerDisabled = this.statePersist.getLocalStorage('retailer-disabled')
    })
    setTimeout(() => {

      if(this.statePersist.getLocalStorage('address-disabled') != null){
        this.addressDisabled = this.statePersist.getLocalStorage('address-disabled')
        if (this.store_data){
          this.addressDisabled = true
        }
      }
      else{
        this.addressDisabled = false
      }

      if(this.statePersist.getLocalStorage('retailer-disabled') != null){
        this.retailerDisabled = this.statePersist.getLocalStorage('retailer-disabled')
      }
      else{
        this.retailerDisabled = false
      }
      
      }, 500);
    
    this.sub3 = this.statePersist.watchStoreListing().subscribe(message => {
    this.getStoreListing()

    })
    this.sub4 = this.statePersist.watchStoreSelected().subscribe(message => {
      setTimeout(() => {
      let selected_store_data = this.statePersist.getLocalStorage('selectedStoreAddress') || ''
      this.selectedStoreId = parseInt(selected_store_data.selectedStoreId);
      this.cdRef.detectChanges()
      this.selectedStoreName = selected_store_data.selectedStoreName
      if(selected_store_data.bonds_account_number){
        this.selectedStoreAccountNo = selected_store_data.bonds_account_number
      }
      this.selectedStorePromotionApply = selected_store_data.store_promotion_apply
      this.statePersist.removeLocalStorage('selectedStoreAddress')
      this.statePersist.setLocalStorage('selectedStoreAddress', {selectedStoreId:this.selectedStoreId, selectedStoreName: this.selectedStoreName, totalStoreCount:this.stores.length, selectedStorePromotionApply: this.selectedStorePromotionApply,selectedStoreAccountNo:this.selectedStoreAccountNo})
        this.cdRef.detectChanges();
      }, 400);
      
    })
    this.getStoreListing()
    
  }

  storeChangeAfterredirection(){
    let selected_store_data = this.statePersist.getLocalStorage('selectedStoreAddress') || ''
    
    if ((this.store_data && selected_store_data && selected_store_data.selectedStoreId != this.store_data.store_id) || (this.store_data && !selected_store_data && this.stores.length > 0 && parseInt(this.stores[0].store_id) != this.store_data.store_id)){
      let payload:any={}
      payload.id = this.store_data.store_id;
      this.changeStoreId(payload)
    }
    else if (this.store_data && !selected_store_data && this.stores.length > 0 && parseInt(this.stores[0].store_id) == this.store_data.store_id){
      this.selectedStoreId = parseInt(this.stores[0].store_id);
      this.selectedStoreAccountNo = this.stores[0].bonds_account_number	
      this.selectedStoreName = this.stores[0].store_name
      this.selectedStorePromotionApply = this.stores[0].store_promotion_apply
      
      this.statePersist.setLocalStorage('selectedStoreAddress', {selectedStoreId:this.selectedStoreId, selectedStoreName: this.selectedStoreName, totalStoreCount:this.stores.length, selectedStorePromotionApply: this.selectedStorePromotionApply, selectedStoreAccountNo:this.selectedStoreAccountNo})
      this.statePersist.emitcategoryDetails('category update')
    }
    else{
      
      this.selectedStoreId = parseInt(selected_store_data.selectedStoreId);
      this.selectedStoreName = selected_store_data.selectedStoreName
      if(selected_store_data.bonds_account_number){
        this.selectedStoreAccountNo = selected_store_data.bonds_account_number
      }else{
        for (let i = 0; i < this.stores.length; i++) {
          if (this.stores[i].store_id == this.selectedStoreId){
            this.selectedStoreAccountNo = this.stores[i].bonds_account_number
          }}
      }	
      this.selectedStorePromotionApply = selected_store_data.store_promotion_apply
    }
  }

  ngOnDestroy() {
    this.sub1.unsubscribe();
    this.sub2.unsubscribe();
    this.sub3.unsubscribe();
    this.sub4.unsubscribe();
  }


  ngAfterViewInit(){
    var user;
    user = this.statePersist.getLocalStorage('currentUser')
    if (this.statePersist.getLocalStorage('default_popup_hide')){
      console.log('')
    }
    else{
      let currentUrl = this.router.url;
      if (currentUrl.includes('/home') && (user.is_telesales_user || user.is_head_office_user || user.is_sales_rep)){
        if (this.modalRef != undefined){
          this.cancelSearch()
        }
        if (!this.store_data){
          this.openModalWithClass(this.templateRef)
        }
        
      }
      
    }
    

  }
  
  selectedStoreId: number;

  selectStoresList = [];

  selectedRetailerId: number;

  selectRetailerList = [];

  changeStoreId(event){
    this.checkStoreActive(event.id)
    // for (let i = 0; i < this.stores.length; i++) {
    //   if (this.stores[i].store_id == event.id){

    //     this.googleAnalyticsService.eventEmitter(SharedConsts.STORE_CHANGE_EVENT, SharedConsts.GOOGLEANALYTICSS_EVENT_CATEGORY_NAME, SharedConsts.STORE_CHANGE_EVENT_ACTION, SharedConsts.GOOGLEANALYTICSS_EVENT_LABEL, SharedConsts.GOOGLEANALYTICSS_EVENT_VALUE);
    //     this.selectedStoreName = this.stores[i].store_name
    //     this.selectedStoreAccountNo = this.stores[i].bonds_account_number
    //     this.selectedStorePromotionApply = this.stores[i].store_promotion_apply
    //     this.selectedStoreId = event.id
    //     this.statePersist.setLocalStorage('selectedStoreAddress', {selectedStoreId:this.selectedStoreId, selectedStoreName: this.selectedStoreName, totalStoreCount:this.stores.length, selectedStorePromotionApply: this.selectedStorePromotionApply, selectedStoreAccountNo: this.selectedStoreAccountNo})
    //   }
    // }
    
  }

  changeRetailerId(retailer){
    this.checkRetailerActive(retailer)
  }

  reloadCurrentRoute() {
    let currentUrl = this.router.url;
    if(currentUrl.includes('/home')){
      this.statePersist.emithomepageDetails('home page update update')
    }
    else if(currentUrl == '/order'){
      this.statePersist.emitmyorderDetails('my orders update')
      this.statePersist.emitcategoryDetails('category update')
    }
    else if(currentUrl.includes('suggested')){
      this.statePersist.emitSuggestedProductListData('suggested list update')
      this.statePersist.emitcategoryDetails('category update')
    }
    else if (!currentUrl.includes('/promotion/') && currentUrl.includes('/product/listing')){
      let product_data
      product_data = this.statePersist.getLocalStorage('product_data')
      product_data['rsp_min'] = ''
      product_data['rsp_max'] = ''
      this.statePersist.emitcategoryDetails('category update')
      this.statePersist.setLocalStorage('product_data',product_data, 'product-data-update')
      this.statePersist.emitstoreListing('store list update')
    }
    else if(currentUrl.includes('/order/order-cart/')){
      this.statePersist.emitreorderDetails('reorder detail update')
      this.statePersist.emitcategoryDetails('category update')
    }
    else if ( currentUrl.includes('/promotion/') && currentUrl.includes('product/listing')){
      this.statePersist.emitPromotionProductsData('promotion product updated')
    }
    else if (currentUrl.includes('/promotion/All')){
      this.statePersist.emitPromotionsData('promotion update')
    }
    
    this.statePersist.setLocalStorage('default_popup_hide', true)
    
    
    this.statePersist.emitminiCartData('mini cart update')
  }

  checkStoreActive(store_id){
 
    this.homeService.checkStoreActive({'store_id': store_id})
    .subscribe(
      response => {
        if (response.status == 1161 || response.status ==1153  || response.status == 1155){
          this.alertService.error(response.response)
        }
        else if (response.status == 403){
          this.router.navigate(['/'])
        }
        else {
          let store_found = false;
        for (let i = 0; i < this.stores.length; i++) {
          if (this.stores[i].store_id == store_id){
            store_found = true
            this.googleAnalyticsService.eventEmitter(SharedConsts.STORE_CHANGE_EVENT, SharedConsts.GOOGLEANALYTICSS_EVENT_CATEGORY_NAME, SharedConsts.STORE_CHANGE_EVENT_ACTION, SharedConsts.GOOGLEANALYTICSS_EVENT_LABEL, SharedConsts.GOOGLEANALYTICSS_EVENT_VALUE);
            this.selectedStoreName = this.stores[i].store_name
            this.selectedStoreAccountNo = this.stores[i].bonds_account_number
            this.selectedStorePromotionApply = this.stores[i].store_promotion_apply
            this.selectedStoreId = store_id
            this.statePersist.removeLocalStorage('selectedStoreAddress')
            this.statePersist.setLocalStorage('selectedStoreAddress', {selectedStoreId:this.selectedStoreId, selectedStoreName: this.selectedStoreName, totalStoreCount:this.stores.length, selectedStorePromotionApply: this.selectedStorePromotionApply,selectedStoreAccountNo:this.selectedStoreAccountNo})
          }
        }
        if (store_found || !this.store_data){
          this.getGlobalData()
        }
        else if (!store_found && this.store_data){
          this.openModalWithClass(this.templateRef3)
        }
        }
        
        


      })
  }

  getGlobalData(){
    this.sharedService.getGlobalValues()
      .subscribe(
        response => {
          this.statePersist.setLocalStorage('global_data', response.response, 'change');
          this.reloadCurrentRoute()
        },
        error => { }
      );
  }


  checkRetailerActive(retailer){
    this.homeService.checkRetailerActive({'retailer_id': retailer.id, 'active_retailer': 1, 'store_id': retailer.store.store_id})
    .subscribe(
      data => {
        if (data.response.msg != ''){
          this.alertService.error(data.response.msg)
        }
        else{
     
          this.selectedRetailerId = parseInt(retailer.id);
          this.selectedRetailerName = retailer.store.store_name;
          this.statePersist.setLocalStorage('selectedRetailer', {'selectedRetailerId': this.selectedRetailerId, 'selectedRetailerName': this.selectedRetailerName})
          this.statePersist.removeLocalStorage('selectedStoreAddress')
          this.noRecord = true;
          this.retailers = [];
          this.nextPage = 1;
          this.totalRetailerCount = 0;
          this.totalRetailerPages = 1
          this.selectedStoreId = parseInt(retailer.store.store_id);
          this.selectedStoreName = retailer.store.store_name 
          this.selectedStoreAccountNo = retailer.store.bonds_account_number
          this.selectedStorePromotionApply = retailer.store.store_promotion_apply
          this.statePersist.setLocalStorage('selectedStoreAddress', {selectedStoreId:this.selectedStoreId, selectedStoreName: this.selectedStoreName, totalStoreCount:retailer.store.store_count, selectedStorePromotionApply: this.selectedStorePromotionApply,selectedStoreAccountNo: this.selectedStoreAccountNo})
          this.modalRef.hide()
          this.reloadCurrentRoute()
        }
        
      })
  }
  logout() {

    localStorage.clear();
    sessionStorage.clear();
    this._compiler.clearCache();
    this.router.navigate(['users/login']);
      
  }
  getStoreListing() {
    var obj, retailerObj;
    if (this.store_data && (this.store_data.is_telesales_user || this.store_data.is_head_office_user || this.store_data.is_sales_rep)){
      this.addressDisabled = true
      this.is_store_input_disabled = true;
      this.selectedRetailerId = this.store_data.retailer_id
      this.selectedRetailerName = this.store_data.retailer_name
      this.statePersist.setLocalStorage('selectedRetailer', {'selectedRetailerId': this.selectedRetailerId, 'selectedRetailerName': this.selectedRetailerName})
    }
    else if (this.store_data && (!this.store_data.is_telesales_user && !this.store_data.is_head_office_user && !this.store_data.is_sales_rep)){
      this.addressDisabled = true
      this.selectedRetailerId = 0
      this.selectedRetailerName = ''
      this.statePersist.removeLocalStorage('selectedRetailer')
    }
    retailerObj = this.statePersist.getLocalStorage('selectedRetailer')
    if(retailerObj){
      this.selectedRetailerId = parseInt(retailerObj.selectedRetailerId);
      this.selectedRetailerName = retailerObj.selectedRetailerName
    }
    if (this.selectedRetailerId){
      obj = {'retailer_id':this.selectedRetailerId}
    }
    else{
      obj = {'retailer_id':''}
    }
    
    this.homeService.getStores(obj)
    .subscribe(
      data => {
        if (data.response) {
          if (data.status == 1150){
            this.openModalWithClass(this.templateRef2)
            setTimeout(() => {
              this.logout()
              this.modalRef.hide()
            }, 2000);
          }
          else{
            this.stores = data.response.stores
          var store_obj =[];
          let storeObj;
          storeObj = this.statePersist.getLocalStorage('selectedStoreAddress')
          for (let i = 0; i < this.stores.length; i++) {
            let address;
            if (this.stores[i].street.length >0)
            {
              address = this.stores[i].street + ', '
            }
            if(this.stores[i].region != '' && this.stores[i].region != null){
              address = address + this.stores[i].region + ', '
            }
            if(this.stores[i].city != '' && this.stores[i].city != null){
              address = address + this.stores[i].city + ', '
            }
            if(this.stores[i].country != '' && this.stores[i].country != null){
              address = address + this.stores[i].country
            }
            store_obj.push({id: parseInt(this.stores[i].store_id), name:address})
            
          }
        
          if(data.response.retailer != ''){
            this.selectedRetailerId = parseInt(data.response.retailer.id);
            this.selectedRetailerName = data.response.retailer.name
            this.statePersist.setLocalStorage('selectedRetailer', {'selectedRetailerId': this.selectedRetailerId, 'selectedRetailerName': this.selectedRetailerName})
          }
          else{
            this.selectedRetailerId = 0;
            this.selectedRetailerName = ''
            this.statePersist.removeLocalStorage('selectedRetailer')
          }
          storeObj = this.statePersist.getLocalStorage('selectedStoreAddress')
          if(!this.store_data && storeObj && this.stores.some(store => parseInt(store.store_id) === storeObj.selectedStoreId)){
            
            this.selectedStoreId = parseInt(storeObj['selectedStoreId']);
            this.selectedStoreName = storeObj.selectedStoreName
            
            this.selectedStorePromotionApply = storeObj.store_promotion_apply
            for (let i = 0; i < this.stores.length; i++) {
              if (this.stores[i].store_id == parseInt(storeObj['selectedStoreId'])){
        
                this.googleAnalyticsService.eventEmitter(SharedConsts.STORE_CHANGE_EVENT, SharedConsts.GOOGLEANALYTICSS_EVENT_CATEGORY_NAME, SharedConsts.STORE_CHANGE_EVENT_ACTION, SharedConsts.GOOGLEANALYTICSS_EVENT_LABEL, SharedConsts.GOOGLEANALYTICSS_EVENT_VALUE);
                this.selectedStoreName = this.stores[i].store_name
                this.selectedStoreAccountNo = this.stores[i].bonds_account_number
                this.selectedStorePromotionApply = this.stores[i].store_promotion_apply
                this.selectedStoreId = parseInt(storeObj['selectedStoreId'])
                this.statePersist.setLocalStorage('selectedStoreAddress', {selectedStoreId:this.selectedStoreId, selectedStoreName: this.selectedStoreName, totalStoreCount:this.stores.length, selectedStorePromotionApply: this.selectedStorePromotionApply, selectedStoreAccountNo: this.selectedStoreAccountNo})
              }
            }
          }
          else{
            if (this.store_data){
              this.storeChangeAfterredirection()
            }
            
            else if (this.stores.length > 0){
              this.selectedStoreId = parseInt(this.stores[0].store_id);
              this.selectedStoreName = this.stores[0].store_name
              this.selectedStoreAccountNo = this.stores[0].bonds_account_number
              this.selectedStorePromotionApply = this.stores[0].store_promotion_apply
              
              this.statePersist.setLocalStorage('selectedStoreAddress', {selectedStoreId:this.selectedStoreId, selectedStoreName: this.selectedStoreName, totalStoreCount:this.stores.length, selectedStorePromotionApply: this.selectedStorePromotionApply, selectedStoreAccountNo: this.selectedStoreAccountNo})
              this.statePersist.emitcategoryDetails('category update')
            }
          }
          
          this.selectStoresList = store_obj;
          

          }
          
        }
      }
    );


  }

  getretailerList(event?: any) {
    let dataObj = {"keyword":this.searchText,"page":this.nextPage, "page_size":this.page_size , "retailer_list": 1}
    this.homeService.retailerList(dataObj)
    .subscribe(
      data => {
        if (data.response) {
          const retailer_list = data.response.retailers;
          this.totalRetailerCount = data.response.retailer_count
          this.totalRetailerPages = data.response.total_pages;
          
          if (this.totalRetailerPages < this.nextPage + 1) {
            this.nextPage = null;
          }
          else {
            this.nextPage += 1;
          }
          if (data.response.retailer_count == 0) {
            this.noRecord = true;
            this.retailers = [];
            this.nextPage = 1;
            this.totalRetailerCount = 0;
            this.totalRetailerPages = 1
          }
          else {
            this.noRecord = false;
  
          }
          for (let i = 0; i < retailer_list.length; i++) {
            this.retailers.push(retailer_list[i]);
          }

          if(event){
            event.target.focus()
          }
          
          this.loading = false;
          this.componentLoaded = true;
        }
      }
    );
  }

  onScrollDown (){
    if ((this.nextPage != 1 && this.nextPage !== null) && !this.loading) {
      this.loading = true;
      this.getretailerList()
    }
  
  }

}
